import { stats } from '@/mocks/faqs';

export default function StatsSection() {
  const colorMap: Record<string, string> = {
    primary: 'bg-primary-100 text-primary-700',
    accent: 'bg-accent-100 text-accent-700',
    secondary: 'bg-secondary-100 text-secondary-700',
  };

  return (
    <section className="py-14 md:py-16 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className={`w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 rounded-xl flex items-center justify-center ${colorMap[stat.color]}`}>
                <i className={`${stat.icon} text-xl md:text-2xl`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-500 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}